import { RunFacetField } from '@/types/schema';

export const HIDDEN_BY_DEFAULT_METADATA_KEYS = [
  'example_version',
  'ls_example_dataset_split',
  'ls_method',
  'num_repetitions',
  'revision_id',
  'ls_run_depth',
  'ls_example_ls_run_depth',
  'LANGSMITH_ENDPOINT',
  'ls_example_LANGSMITH_ENDPOINT',
  'LANGSMITH_API_KEY',
  'ls_example_LANGSMITH_API_KEY',
  'LANGSMITH_PROJECT',
  'ls_example_LANGSMITH_PROJECT',
  'LANGSMITH_TRACING',
  'ls_example_LANGSMITH_TRACING',
  'LANGSMITH_TRACING_V2',
  'ls_example_LANGSMITH_TRACING_V2',
  'LANGCHAIN_TRACING',
  'ls_example_LANGCHAIN_TRACING',
  'LANGCHAIN_TRACING_V2',
  'ls_example_LANGCHAIN_TRACING_V2',
];

export function isExampleMetadata(metadata: RunFacetField | null) {
  return metadata?.value.startsWith('ls_example_');
}

export function getKeyName(metadata: RunFacetField | null) {
  return isExampleMetadata(metadata)
    ? metadata?.value.split('ls_example_')[1]
    : metadata?.value;
}

/**
 * Calculates the maximum number of fraction digits to display for a number.
 *
 * Shows at least 2 decimal places, at most 4 decimal places,
 * and aside from those constraints shows at most 4 sig figs.
 * Examples:
 * - 0.6 -> 0.60 (2 decimal places)
 * - 0.12345 -> 0.1234 (4 decimal places)
 * - 999.123 -> 999.12 (2 decimal places)
 *
 * @param value The number to calculate max fraction digits for
 * @returns The maximum number of fraction digits to display
 */
export const calculateMaxFractionDigits = (value?: number | null): number => {
  if (value == null) return 2; // Default to 2 decimal places

  const numDigits = value >= 1 ? Math.floor(Math.log10(value)) + 1 : 0;
  return Math.min(4, Math.max(2, 4 - numDigits));
};
